import { useState } from "react";
import LegalPage from "../components/LegalPage";
import styles from "./Contact.module.css";

const SUBJECTS = [
  "Customer Service Inquiry",
  "Product Return",
  "Dealer of Record",
  "Government Quote Request",
  "Sponsorship Request / Question",
  "Warranty Question",
  "Pro-Purchase Question",
  "Referral Program Request",
  "Hunting Conservation Request",
  "Media Inquiries",
];

export default function Contact() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: SUBJECTS[0],
    message: "",
  });
  const [sent, setSent] = useState(false);

  function field(k, v) { setForm((f) => ({ ...f, [k]: v })); }
  function submit(e) {
    e.preventDefault();
    // Stub — when the BFF lands, POST this to /api/contact.
    setSent(true);
  }

  return (
    <LegalPage
      eyebrow="Get in Touch"
      title="Contact Mystery Ranch"
      summary="Customer service is staffed Monday–Friday 9am–5pm Mountain Time. The form below routes your inquiry to the right team."
      sections={[
        {
          id: "phones",
          title: "Phone",
          dl: [
            { label: "Customer Service",  value: "1-833-548-1999" },
            { label: "Warranty",          value: "406-548-3234" },
            { label: "Business",          value: "406-585-1428" },
            { label: "Dealer Services",   value: "1-877-499-8466" },
          ],
        },
        {
          id: "hq",
          title: "Headquarters",
          body: "1750 Evergreen Drive, Bozeman, MT 59715.  We do not operate a retail store; warranty and repair drop-offs are accepted as time permits.",
        },
        {
          id: "international",
          title: "International Government Procurement",
          body: "For non-U.S. government contracts, contact Sean Evangelista (International Sales). Include your full name, organization / unit, country, and role.",
        },
        {
          id: "form",
          title: "Send a Message",
          // Custom JSX rendered below the LegalPage list — we re-export
          // the form via the `body` slot of the section.
          body: undefined,
        },
      ]}
      footer={
        <form className={styles.form} onSubmit={submit}>
          {sent ? (
            <div className={styles.sent}>
              <strong>Thanks — we got it.</strong>
              <p>We'll reply within two business days.</p>
            </div>
          ) : (
            <>
              <div className={styles.grid2}>
                <Field label="First name" required value={form.firstName} onChange={(v) => field("firstName", v)} />
                <Field label="Last name"  required value={form.lastName}  onChange={(v) => field("lastName", v)} />
                <Field label="Email" type="email" required value={form.email} onChange={(v) => field("email", v)} />
                <Field label="Phone" type="tel" value={form.phone} onChange={(v) => field("phone", v)} />
              </div>

              <label className={styles.field}>
                <span className={styles.label}>Subject<em>*</em></span>
                <select
                  required
                  value={form.subject}
                  onChange={(e) => field("subject", e.target.value)}
                  className={styles.input}
                >
                  {SUBJECTS.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </label>

              <label className={styles.field}>
                <span className={styles.label}>Message<em>*</em></span>
                <textarea
                  required
                  value={form.message}
                  onChange={(e) => field("message", e.target.value)}
                  rows={5}
                  className={styles.textarea}
                />
              </label>

              <button type="submit" className={styles.submit}>Send Message</button>
            </>
          )}
        </form>
      }
    />
  );
}

function Field({ label, value, onChange, type = "text", required = false }) {
  return (
    <label className={styles.field}>
      <span className={styles.label}>{label}{required && <em>*</em>}</span>
      <input
        type={type}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className={styles.input}
      />
    </label>
  );
}
